import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useTrips() {
  const [trips, setTrips]     = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/trips");
      setTrips(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load trips");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  async function createTrip(payload) {
    const { data } = await api.post("/api/trips", payload);
    setTrips(prev => [data, ...prev]);
    return data;
  }

  async function cancelTrip(id) {
    const { data } = await api.patch(`/api/trips/${id}/cancel`);
    setTrips(prev => prev.map(t => (t.id === id ? data : t)));
    return data;
  }

  async function markStarted(id) {
    const { data } = await api.patch(`/api/trips/${id}/mark-started`);
    setTrips(prev => prev.map(t => (t.id === id ? data : t)));
    return data;
  }

  async function markCompleted(id) {
    const { data } = await api.patch(`/api/trips/${id}/mark-completed`);
    setTrips(prev => prev.map(t => (t.id === id ? data : t)));
    return data;
  }

  return { trips, loading, createTrip, cancelTrip, markStarted, markCompleted, reload: load };
}
